// extracted by mini-css-extract-plugin
module.exports = {"form":"_5D1B7odQ","title":"_5DOuvjmm","checkbox-container":"_5DryRG3a"};